/* =============================================================================
   Forevermore Magnets — theme.js
   Minimal global behavior: mobile menu toggle only. Everything else is CSS.
   ========================================================================== */
(function () {
  'use strict';

  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('MobileNav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function () {
    var open = nav.classList.toggle('is-open');
    nav.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-open')) {
      nav.classList.remove('is-open');
      nav.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  });
})();
